import { useLayerStore } from '@/store/layerStore';
import type { LayerConfig } from '@/store/layerStore';

function LayerRow({ layer }: { layer: LayerConfig }) {
  const toggleLayer = useLayerStore((s) => s.toggleLayer);
  const setOpacity = useLayerStore((s) => s.setOpacity);
  const setFilterMinScore = useLayerStore((s) => s.setFilterMinScore);

  return (
    <div
      className="py-2 border-b"
      style={{ borderColor: '#21262d' }}
    >
      {/* Checkbox + label row */}
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={layer.visible}
          onChange={() => toggleLayer(layer.id)}
          className="accent-blue-500"
        />
        <span style={{ color: '#c9d1d9' }}>{layer.label}</span>

        {layer.loading && (
          <span className="animate-spin inline-block" style={{ color: '#8b949e' }}>
            ...
          </span>
        )}

        {layer.error && (
          <span
            title={layer.error}
            className="font-bold"
            style={{ color: '#f85149' }}
          >
            !
          </span>
        )}
      </label>

      {/* Expanded controls when visible */}
      {layer.visible && (
        <div className="mt-2 ml-5 space-y-1">
          {/* Opacity slider */}
          <div className="flex items-center gap-2">
            <span style={{ color: '#8b949e', minWidth: '52px' }}>Opacity</span>
            <input
              type="range"
              min="0"
              max="100"
              value={Math.round(layer.opacity * 100)}
              onChange={(e) => setOpacity(layer.id, Number(e.target.value) / 100)}
              className="flex-1 h-1"
            />
            <span style={{ color: '#8b949e', minWidth: '28px', textAlign: 'right' }}>
              {Math.round(layer.opacity * 100)}%
            </span>
          </div>

          {/* Min Score slider */}
          <div className="flex items-center gap-2">
            <span style={{ color: '#8b949e', minWidth: '52px' }}>Score</span>
            <input
              type="range"
              min="0"
              max="100"
              value={layer.filterMinScore}
              onChange={(e) => setFilterMinScore(layer.id, Number(e.target.value))}
              className="flex-1 h-1"
            />
            <span style={{ color: '#8b949e', minWidth: '28px', textAlign: 'right' }}>
              {layer.filterMinScore}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export function LayerPanel() {
  const layers = useLayerStore((s) => s.layers);

  return (
    <div
      className="absolute left-4 top-4 w-64 rounded-lg border p-3 z-10 font-mono text-xs"
      style={{
        background: '#0d1117',
        borderColor: '#30363d',
        color: '#c9d1d9',
      }}
    >
      <h3
        className="text-sm font-bold mb-3"
        style={{ color: '#58a6ff' }}
      >
        Overlay Layers
      </h3>

      {Object.values(layers).map((layer) => (
        <LayerRow key={layer.id} layer={layer} />
      ))}
    </div>
  );
}
